import React from "react";

export default function CustomContainer({ title, value }) {
  return (
    <div className="relative w-full text-black group">
      <div className="flex justify-center py-4 bg-white">
        <h1 className="text-black">{title}</h1>
      </div>
      <div className="flex justify-center duration-300 bg-white group-hover:bg-custom-yellow">
        <h1 className="text-2xl text-black">{value}</h1>
      </div>
    </div>
  );
}
